import React from "react";
import { Box } from "@mui/material";
import { useOrganization, useUser } from "@clerk/react";
import { NotificationsBell } from "@scoutingops/notifications";
import { MainNav, platformBrand } from "@scoutingops/ui";

import { SiteGuard } from "@/components/auth/app-access-guard";
import { UserMenuButton } from "@/components/core/user-menu-button";
import { appConfig } from "@/config/app";
import { useSupabaseClient } from "@/hooks/use-supabase-client";

export interface LayoutProps {
  children?: React.ReactNode;
}

export function Layout({ children }: LayoutProps): React.JSX.Element {
  // useSupabaseClient returns a useCallback'd getter — NotificationsBell keeps
  // it in the dep array of the effect that opens its realtime channel, so an
  // inline arrow here would resubscribe on every render.
  const getSupabase = useSupabaseClient();
  const { organization } = useOrganization();
  const { user } = useUser();

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
      }}
    >
      {/* The app shell labels itself with the solution name, so the nav agrees
          with the browser tab title; everything else comes from the platform
          defaults. socialLinks is emptied deliberately: social icons belong on
          the marketing surface, not inside the authenticated app. */}
      <MainNav
        brand={{ ...platformBrand, name: appConfig.name, logoAlt: appConfig.name }}
        notificationsSlot={<NotificationsBell getSupabase={getSupabase} orgId={organization?.id} userId={user?.id} />}
        socialLinks={[]}
        userMenu={<UserMenuButton />}
      />
      <Box component="main" sx={{ flex: "1 1 auto" }}>
        <SiteGuard>{children}</SiteGuard>
      </Box>
    </Box>
  );
}
